/**
 * ewc-bundle — ofertas por quantidade na página de produto, independente de tema.
 *
 * O widget nasce escondido no fim do body e o JS o leva para logo acima do botão de
 * compra, achando sozinho o formulário de /cart/add que o cliente de fato envia
 * (não o da gaveta, não o do upsell). A partir daí ele intercepta o envio e monta o
 * pedido: as unidades da barra escolhida (cada uma com a variante escolhida), os
 * upsells marcados e os brindes liberados — tudo pelo /cart/add.js.
 *
 * O desconto NÃO é aplicado aqui: o widget mostra a conta que o checkout vai
 * cobrar (a mesma do ofertas.py). Quem cobra é o desconto automático da loja.
 *
 * Falha aberto: qualquer erro deixa a página e o botão do tema como estavam.
 */
(function () {
  'use strict';
  if (window.EwcBundle) return;

  var SEL_PICKER = 'variant-selects,variant-radios,variant-picker,.product-variant-picker,.product-form__variants,[data-product-option],.product-form__input--dropdown,.product-form__input--pill,.product-form__input--swatch';
  var SEL_FORA = 'cart-drawer,.cart-drawer,#shopify-section-cart-drawer,#ewc-cart-root,[data-is-cart-upsell],.upsell,.upsells-container,.drawer,.cart-drawer-upsells-container,.ewc-cart';

  function el(tag, classe, texto) { var n = document.createElement(tag); if (classe) n.className = classe; if (texto != null) n.textContent = texto; return n; }
  function dinheiro(cent, fmt) {
    var v = (cent / 100).toFixed(2), p = v.split('.'), i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/g, i + '.' + p[1]).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, i)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, i.replace(/,/g, '.') + ',' + p[1]).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, i.replace(/,/g, '.')).replace(/<[^>]*>/g, '');
  }
  function enxuto(t) { return String(t).replace(/(\d)\.00(?!\d)/g, '$1'); }
  // quantas unidades do brinde a barra i libera: `quantidades` por número de barra ({"2": 2, "3": 4})
  // ou, sem ela, 1 a partir de `a_partir_da_barra`
  function qtdBrinde(g, i) {
    if (g.quantidades) return parseInt(g.quantidades[String(i + 1)] || 0, 10) || 0;
    return (i + 1) >= (g.a_partir_da_barra || 1) ? 1 : 0;
  }

  /* ------------------------------------------------------ formulário de compra */
  function achar(root, seletorManual) {
    if (seletorManual) { var m = document.querySelector(seletorManual); if (m) return m; }
    function temBotao(f) { return !!f.querySelector('button[name="add"],[type="submit"]'); }
    function deFora(f) { return !!(f.closest && f.closest(SEL_FORA)); }
    var comId = null, comBotao = null, qualquer = null;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i]; if (deFora(f) || root.contains(f)) continue;
      var id = !!f.querySelector('[name="id"]'), botao = temBotao(f);
      if (id && botao) return f;
      if (id && !comId) comId = f; if (botao && !comBotao) comBotao = f; if (!qualquer) qualquer = f;
    }
    return comBotao || comId || qualquer;
  }
  function posicionar(root, form) {
    // âncora explícita: um elemento [data-ewc-bundle-anchor] no tema recebe o widget (referência que
    // põe a oferta longe do botão de compra); sem âncora vale o encaixe automático acima do botão
    var selAncora = root.getAttribute('data-ewc-anchor');
    var ancora = selAncora ? document.querySelector(selAncora) : document.querySelector('[data-ewc-bundle-anchor]:not([data-ewc-ocupada])');
    if (ancora) { ancora.setAttribute('data-ewc-ocupada', '1'); ancora.appendChild(root); root.hidden = false; return true; }
    var alvo = form.querySelector('.product-form__buttons') || form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]') || form;
    if (alvo !== form && alvo.closest) alvo = alvo.closest('.product-form__buttons') || alvo;
    var subir = alvo.closest ? alvo.closest('product-form,.product-form,.product-form__buttons-wrapper') : null;
    if (subir && subir.parentNode && subir !== form.parentNode) alvo = subir;
    if (!alvo.parentNode) return false;
    alvo.parentNode.insertBefore(root, alvo);
    root.hidden = false;
    return true;
  }

  /* ------------------------------------------------------ variantes */
  function Variantes(produto) {
    this.p = produto; this.opcoes = produto.opcoes || []; this.v = produto.variantes || [];
  }
  Variantes.prototype.porOpcoes = function (escolha) {
    for (var i = 0; i < this.v.length; i++) { var ok = true; for (var j = 0; j < escolha.length; j++) if (this.v[i].opcoes[j] !== escolha[j]) { ok = false; break; } if (ok) return this.v[i]; }
    return null;
  };
  Variantes.prototype.valoresDisponiveis = function (indice, prefixo) {
    // valores da opção `indice` que existem (e estão disponíveis) dado o prefixo já escolhido
    var vistos = {}, lista = [];
    for (var i = 0; i < this.v.length; i++) {
      var ok = true; for (var j = 0; j < indice; j++) if (this.v[i].opcoes[j] !== prefixo[j]) { ok = false; break; }
      if (!ok) continue;
      var val = this.v[i].opcoes[indice];
      if (!(val in vistos)) { vistos[val] = false; lista.push(val); }
      if (this.v[i].disponivel) vistos[val] = true;
    }
    return lista.map(function (x) { return { valor: x, disponivel: vistos[x] }; });
  };
  Variantes.prototype.porId = function (id) { for (var i = 0; i < this.v.length; i++) if (String(this.v[i].id) === String(id)) return this.v[i]; return null; };

  /* ------------------------------------------------------ widget */
  function Widget(root) {
    var no = root.querySelector('[data-ewc-bundle-config]');
    var d = JSON.parse(no.textContent);
    this.root = root; this.cfg = d.cfg || {}; this.produto = d.produto; this.fmt = d.moneyFormat; this.rotas = d.rotas || {};
    this.raiz = ((window.Shopify && Shopify.routes && Shopify.routes.root) || this.rotas.raiz || '/').replace(/\/?$/, '/');
    this.vars = new Variantes(this.produto);
    this.barras = this.cfg.barras || [];
    this.selecionada = Math.max(1, Math.min(this.barras.length, parseInt(this.cfg.preselecionada || 1, 10))) - 1;
    this.unidades = [];   // [barraIndex][unidade] = escolha (array de valores de opção)
    this.extras = {};     // dados de produto dos upsells/brindes por handle
    this.ocupado = false;
    this.inst = root.getAttribute('data-ewc-inst') || '';   // segunda instancia na pagina (produto em destaque)
    this.form = achar(root, root.getAttribute('data-ewc-form') || this.cfg.seletor_formulario);
    if (!this.form) throw new Error('formulário de compra não encontrado');
    this.aplicarEstilo(); this.montar();
    if (!posicionar(root, this.form)) throw new Error('não achei onde encaixar o widget');
    if (this.cfg.esconder_seletor_do_tema !== false && this.cfg.variantes_diferentes !== false && this.vars.v.length > 1) this.esconderPicker();
    this.ligar(); this.render(); this.carregarExtras();
  }
  Widget.prototype.aplicarEstilo = function () {
    var e = this.cfg.estilo || {}, r = this.root.style;
    if (e.cor_destaque) r.setProperty('--eb-acento', e.cor_destaque);
    if (e.cor_selo) r.setProperty('--eb-selo', e.cor_selo);
    if (e.fundo_barra) r.setProperty('--eb-fundo', e.fundo_barra);
    if (e.fundo_selecionada) r.setProperty('--eb-fundo-sel', e.fundo_selecionada);
    if (e.anel) r.setProperty('--eb-anel', e.anel);
    if (e.raio != null) r.setProperty('--eb-raio', e.raio + 'px');
    if (e.fonte) r.setProperty('--eb-fonte', e.fonte);
    // o CSS da config tem o mesmo peso do CSS do kit: ele precisa vir DEPOIS da folha do kit. O widget sobe
    // para dentro da seção do produto e a folha fica no fim da página; por isso o estilo entra logo após ela
    if (e.css) {
      var st = el('style'); st.textContent = e.css; st.setAttribute('data-ewc-estilo', '');
      var folha = document.querySelector('link[href*="ewc-bundle.css"]');
      if (folha && folha.parentNode) folha.parentNode.insertBefore(st, folha.nextSibling); else this.root.appendChild(st);
    }
  };
  Widget.prototype.esconderPicker = function () {
    var f = this.form, secao = f.closest('.shopify-section,section,[id^="shopify-section"]') || document;
    secao.querySelectorAll(SEL_PICKER).forEach(function (n) { if (!n.closest('.ewc-bundle')) n.classList.add('ewc-esconde-seletor'); });
  };
  Widget.prototype.variantePadrao = function () {
    var id = this.form.querySelector('[name="id"]'); var v = id && this.vars.porId(id.value);
    if (!v) v = this.vars.v.filter(function (x) { return x.disponivel; })[0] || this.vars.v[0];
    return v;
  };
  Widget.prototype.precoUnitario = function () { var v = this.variantePadrao(); return v ? v.preco : 0; };
  Widget.prototype.compareUnitario = function () { var v = this.variantePadrao(); return v && v.compare > v.preco ? v.compare : 0; };

  // Total e preço cheio da barra i, em centavos. Com `forma` na config a conta soma o preço da variante
  // escolhida em CADA unidade (produto com preço por tamanho); sem `forma` vale o total fixo de antes.
  Widget.prototype.contaDaBarra = function (i) {
    var b = this.barras[i], padrao = this.variantePadrao(), usarCompare = (this.cfg.mostrar || {}).usar_compare_at !== false;
    var p = this.precoUnitario(), cmp = this.compareUnitario();
    if (!b.forma || b.forma === 'bxgy') {
      var fixo = Math.round((b.total != null ? b.total : (p * b.q) / 100) * 100);
      return { total: fixo, cheio: ((usarCompare && cmp > 0) ? cmp : p) * b.q };
    }
    var soma = 0, cheio = 0;
    for (var u = 0; u < b.q; u++) {
      var esc = this.unidades[i] && this.unidades[i][u];
      var v = (this.cfg.variantes_diferentes === false || !esc) ? padrao : (this.vars.porOpcoes(esc) || padrao);
      soma += v.preco; cheio += (usarCompare && v.compare > v.preco) ? v.compare : v.preco;
    }
    var total = soma;
    if (b.forma === 'por_unidade' && b.cada_off != null) total = soma - Math.round(b.cada_off * 100) * b.q;
    else if (b.forma === 'valor_no_pedido' && b.valor_off != null) total = soma - Math.round(b.valor_off * 100);
    else if (b.forma === 'porcentagem' && b.pct != null) total = Math.round(soma * (100 - b.pct) / 100);
    return { total: Math.max(0, total), cheio: cheio };
  };

  Widget.prototype.montar = function () {
    var self = this, cfg = this.cfg;
    this.root.querySelectorAll(':scope > :not(script):not(style)').forEach(function (n) { n.remove(); });
    // marcacao 'kaching': a mesma árvore de caixas do widget do app. É o que deixa o comparador de árvore
    // parear barra com barra e texto com texto; sem ela o pareamento escorrega e a diferença vira ruído
    var k = cfg.marcacao === 'kaching', alvo = this.root, lista = this.root;
    if (k) {
      var app = el('div', 'ewc-bundle__app'), bloco = el('div', 'ewc-bundle__bloco');
      app.appendChild(bloco); this.root.appendChild(app); alvo = bloco;
    }
    if (cfg.titulo_bloco) alvo.appendChild(el('div', 'ewc-bundle__titulo', cfg.titulo_bloco));
    if (k) { lista = el('div', 'ewc-bundle__barras'); alvo.appendChild(lista); }
    this.nosBarras = [];
    this.barras.forEach(function (b, i) {
      var lab = el('label', 'ewc-bundle__barra'); lab.setAttribute('data-ewc-bar', i + 1);
      var radio = el('input'); radio.type = 'radio'; radio.name = 'ewc-bundle-bar' + self.inst; radio.value = String(i);
      var casca = null;
      if (k) {
        casca = el('div', 'ewc-bundle__bar'); radio.id = 'ewc-bundle-bar' + self.inst + '-' + i; lab.htmlFor = radio.id;
        casca.appendChild(radio); casca.appendChild(lab);
      } else lab.appendChild(radio);
      if (b.selo) {
        if (k) { var sw = el('div', 'ewc-bundle__selo-wrap'); sw.appendChild(el('div', 'ewc-bundle__selo', b.selo)); lab.appendChild(sw); }
        else lab.appendChild(el('span', 'ewc-bundle__selo', b.selo));
      }
      var cab = el('div', 'ewc-bundle__cabeca'), invol = null, conteudo = cab;
      if (k) { invol = el('div', 'ewc-bundle__wrapper'); invol.appendChild(cab); }
      cab.appendChild(el(k ? 'div' : 'span', 'ewc-bundle__bolinha'));
      if (b.imagem) { var bi = el('img', 'ewc-bundle__imagem'); bi.src = b.imagem; bi.alt = ''; bi.loading = 'lazy'; cab.appendChild(bi); }
      if (k) { conteudo = el('div', 'ewc-bundle__conteudo'); cab.appendChild(conteudo); }
      var tx = el('div', 'ewc-bundle__textos');
      var nome = el(k ? 'span' : 'div', 'ewc-bundle__nome'); nome.textContent = b.titulo || (b.q + ' un');
      if (b.etiqueta) nome.appendChild(el('span', 'ewc-bundle__etiqueta', b.etiqueta));
      if (k) { var l1 = el('div', 'ewc-bundle__linha1'); l1.appendChild(nome); tx.appendChild(l1); } else tx.appendChild(nome);
      var sub = null;
      if (b.subtitulo) {
        sub = el('div', 'ewc-bundle__sub'); sub.innerHTML = b.subtitulo;
        if (k) { var l2 = el('div', 'ewc-bundle__linha2'); l2.appendChild(sub); tx.appendChild(l2); } else tx.appendChild(sub);
      }
      conteudo.appendChild(tx);
      var pr = el('div', 'ewc-bundle__precos'); pr.appendChild(el(k ? 'div' : 'span', 'ewc-bundle__preco')); pr.appendChild(el(k ? 'div' : 'span', 'ewc-bundle__cheio'));
      conteudo.appendChild(pr); lab.appendChild(invol || cab);
      // no desenho do Kaching a escolha por unidade mora dentro do invólucro, abaixo da linha principal
      var un = el('div', k ? 'ewc-bundle__variantes' : 'ewc-bundle__unidades'); (invol || lab).appendChild(un);
      var ex = el('div', 'ewc-bundle__extras'); lab.appendChild(ex);
      var fb = null;
      if (self.brindesDaBarra(i).length) { fb = el('div', 'ewc-bundle__brindes'); lab.appendChild(fb); }
      lista.appendChild(casca || lab);
      self.nosBarras.push({ lab: lab, radio: radio, preco: pr.firstChild, cheio: pr.lastChild, unidades: un, extras: ex, sub: sub, brindes: fb });
      self.unidades[i] = [];
    });
    this.renderBrindesNaBarra();
    this.propriedade = el('input'); this.propriedade.type = 'hidden'; this.propriedade.name = 'properties[_ewc_bundle]'; this.propriedade.setAttribute('data-ewc-injected', '1');
    this.form.appendChild(this.propriedade);
  };

  Widget.prototype.render = function () {
    var self = this, cfg = this.cfg, p = this.precoUnitario(), cmp = this.compareUnitario();
    var usarCompare = (cfg.mostrar || {}).usar_compare_at !== false && cmp > 0;
    this.barras.forEach(function (b, i) {
      var n = self.nosBarras[i], sel = i === self.selecionada;
      n.lab.classList.toggle('is-selected', sel); n.radio.checked = sel;
      var conta = self.contaDaBarra(i), total = conta.total, cheioTotal = conta.cheio;
      var cada = b.forma ? Math.round(total / b.q) : Math.round((b.por_unidade != null ? b.por_unidade : total / b.q / 100) * 100);
      if (n.sub && /\{\{\s*(saved_total|economia)\s*\}\}/.test(b.subtitulo || '')) {
        var eco = b.subtitulo.replace(/\{\{\s*(saved_total|economia)\s*\}\}/g, function () { return enxuto(dinheiro(Math.max(0, cheioTotal - total), self.fmt)); });
        if (n.sub.innerHTML !== eco) n.sub.innerHTML = eco;
      }
      if ((cfg.mostrar || {}).por_unidade) {
        n.preco.textContent = enxuto(dinheiro(cada, self.fmt)) + ' each';
        var cheioCada = usarCompare ? cmp : p;
        n.cheio.textContent = cheioCada > cada ? enxuto(dinheiro(cheioCada, self.fmt)) : '';
      } else {
        n.preco.textContent = enxuto(dinheiro(total, self.fmt));
        n.cheio.textContent = cheioTotal > total ? enxuto(dinheiro(cheioTotal, self.fmt)) : '';
      }
      // Kaching: cada barra guarda a sua escolha e a lista existe em todas (o CSS mostra só a da escolhida)
      if (cfg.marcacao === 'kaching') self.renderVariantesK(i);
      if (sel) { if (cfg.marcacao !== 'kaching') self.renderUnidades(i); self.renderExtras(i); }
    });
    this.atualizarForm();
  };

  /* ------------------------------------------------------ escolha por unidade no desenho do Kaching:
     nomes das opções numa linha, e por unidade uma linha com a foto da variante e uma lista suspensa
     por opção (caixa com a bolinha da cor e o valor; a lista aberta flutua abaixo, ou acima quando
     não cabe, como a do app) */
  Widget.prototype.renderVariantesK = function (i) {
    var self = this, b = this.barras[i], cont = this.nosBarras[i].unidades;
    cont.innerHTML = '';
    if (this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) return;
    var padrao = this.inicial || (this.inicial = this.variantePadrao());
    var nomes = el('div', 'ewc-bundle__variante-nomes');
    this.vars.opcoes.forEach(function (o) { nomes.appendChild(el('span', null, o)); });
    cont.appendChild(nomes);
    for (var u = 0; u < b.q; u++) {
      if (!this.unidades[i][u]) this.unidades[i][u] = padrao.opcoes.slice();
      var esc = this.unidades[i][u], v = this.vars.porOpcoes(esc) || padrao;
      var wrap = el('div', 'ewc-bundle__variante-wrap'), item = el('div', 'ewc-bundle__variante'), cv = el('div', 'ewc-bundle__variante-conteudo');
      if (v.imagem) { var im = el('img', 'ewc-bundle__variante-img'); im.src = v.imagem; im.alt = ''; cv.appendChild(im); }
      var main = el('div', 'ewc-bundle__variante-main'), sels = el('div', 'ewc-bundle__variante-selects');
      this.vars.opcoes.forEach(function (nome, k) { sels.appendChild(self.caixaK(i, u, k, nome, esc)); });
      main.appendChild(sels); cv.appendChild(main); item.appendChild(cv); wrap.appendChild(item); cont.appendChild(wrap);
    }
  };
  Widget.prototype.coresDe = function (nome) {
    var s = this.cfg.swatches;
    return s && s.opcao && s.opcao.toLowerCase() === String(nome).toLowerCase() && s.cores ? s.cores : null;
  };
  // bolinha da cor: a borda é a própria cor 10% mais escura, canal a canal (a conta do app)
  Widget.prototype.corK = function (cor) {
    var c = el('div', 'ewc-bundle__cor'); c.style.setProperty('--eb-cor', cor || '#fff');
    var h = /^#?([0-9a-f]{6})$/i.exec(String(cor || '').trim());
    if (h) {
      var n = parseInt(h[1], 16), rgb = [n >> 16 & 255, n >> 8 & 255, n & 255].map(function (x) { return Math.max(0, x - Math.round(x * 0.1)); });
      c.style.setProperty('--eb-cor-borda', 'rgb(' + rgb.join(', ') + ')');
    }
    return c;
  };
  Widget.prototype.caixaK = function (i, u, k, nome, esc) {
    var cores = this.coresDe(nome);
    if (!cores) {
      // opção sem bolinha (tamanho): o app usa a lista simples do navegador, com o mesmo desenho de caixa
      var s = el('select', 'ewc-bundle__select');
      s.setAttribute('data-ewc-bi', i); s.setAttribute('data-ewc-un', u); s.setAttribute('data-ewc-opt', k); s.setAttribute('aria-label', nome);
      this.vars.valoresDisponiveis(k, esc).forEach(function (x) { var o = el('option', null, x.valor + (x.disponivel ? '' : ' (Sold out)')); o.value = x.valor; o.disabled = !x.disponivel; s.appendChild(o); });
      s.value = esc[k];
      return s;
    }
    var dd = el('div', 'ewc-bundle__dropdown'), cb = el('span', 'ewc-bundle__select');
    cb.setAttribute('role', 'combobox'); cb.setAttribute('aria-expanded', 'false'); cb.setAttribute('aria-label', nome); cb.tabIndex = 0;
    cb.setAttribute('data-ewc-bi', i); cb.setAttribute('data-ewc-un', u); cb.setAttribute('data-ewc-opt', k);
    if (cores) cb.appendChild(this.corK(cores[esc[k]]));
    cb.appendChild(el('span', null, esc[k]));
    dd.appendChild(cb);
    return dd;
  };
  Widget.prototype.abrirLista = function (cb) {
    var self = this; this.fecharLista();
    var i = +cb.getAttribute('data-ewc-bi'), u = +cb.getAttribute('data-ewc-un'), k = +cb.getAttribute('data-ewc-opt');
    var esc = this.unidades[i][u], cores = this.coresDe(this.vars.opcoes[k]);
    var lista = el('div', 'ewc-bundle__opcoes'); lista.setAttribute('role', 'listbox');
    this.vars.valoresDisponiveis(k, esc).forEach(function (x) {
      var o = el('span', 'ewc-bundle__opcao' + (x.valor === esc[k] ? ' is-focused' : '') + (x.disponivel ? '' : ' is-off'));
      o.setAttribute('role', 'option'); o.setAttribute('aria-selected', String(x.valor === esc[k])); o.setAttribute('data-value', x.valor);
      if (cores) o.appendChild(self.corK(cores[x.valor]));
      o.appendChild(el('span', null, x.valor));
      lista.appendChild(o);
    });
    cb.parentNode.appendChild(lista); cb.setAttribute('aria-expanded', 'true');
    this.aberta = { cb: cb, lista: lista, i: i, u: u, k: k };
    this.posicionarLista();
  };
  Widget.prototype.posicionarLista = function () {
    var a = this.aberta; if (!a) return;
    var r = a.cb.getBoundingClientRect(), h = a.lista.offsetHeight, w = a.lista.offsetWidth;
    var alto = window.innerHeight, largo = document.documentElement.clientWidth;
    // abaixo a 2px; quando não cabe embaixo vai para o lado que corta menos (o 'flip' do app);
    // na horizontal nunca a menos de 8px da borda
    var sobraBaixo = Math.max(0, r.bottom + 2 + h - alto), sobraCima = Math.max(0, h - (r.top - 2));
    var topo = sobraBaixo > 0 && sobraCima < sobraBaixo ? r.top - 2 - h : r.bottom + 2;
    a.lista.style.top = topo + 'px';
    a.lista.style.left = Math.max(8, Math.min(r.left, largo - 8 - w)) + 'px';
  };
  Widget.prototype.fecharLista = function () {
    var a = this.aberta; if (!a) return;
    if (a.lista.parentNode) a.lista.parentNode.removeChild(a.lista);
    a.cb.setAttribute('aria-expanded', 'false'); this.aberta = null;
  };
  Widget.prototype.escolherK = function (valor) {
    var a = this.aberta; if (!a) return;
    var esc = this.unidades[a.i][a.u]; esc[a.k] = valor;
    for (var j = a.k + 1; j < this.vars.opcoes.length; j++) {
      var vals = this.vars.valoresDisponiveis(j, esc);
      if (!vals.some(function (x) { return x.valor === esc[j]; })) esc[j] = (vals.filter(function (x) { return x.disponivel; })[0] || vals[0] || {}).valor;
    }
    var foco = { i: a.i, u: a.u, k: a.k };
    this.fecharLista(); this.render();
    this.sincronizar(this.vars.porOpcoes(esc));
    var cb = this.root.querySelector('.ewc-bundle__select[data-ewc-bi="' + foco.i + '"][data-ewc-un="' + foco.u + '"][data-ewc-opt="' + foco.k + '"]');
    if (cb) cb.focus({ preventScroll: true });
  };
  // a variante escolhida numa unidade vira a variante da página (galeria, endereço), como faz o app;
  // o tema recebe 'ewc-bundle:variante' no formulário e decide o que atualizar
  Widget.prototype.sincroniza = function () {
    var c = this.cfg; if (c.variantes_diferentes === false || this.vars.v.length <= 1) return false;
    return c.sincronizar_variante != null ? !!c.sincronizar_variante : c.marcacao === 'kaching';
  };
  Widget.prototype.sincronizar = function (v) {
    if (!v || !this.sincroniza()) return;
    var id = this.form.querySelector('[name="id"]');
    if (id && String(id.value) === String(v.id)) return;
    if (id) id.value = v.id;
    this.form.dispatchEvent(new CustomEvent('ewc-bundle:variante', { bubbles: true, detail: { id: v.id } }));
  };

  // brinde com `na_barra` (desenho do Kaching): faixa com foto, texto e preço cheio riscado DENTRO de
  // cada barra que o libera, escolhida ou não; o preço riscado é o de tabela vezes a quantidade
  Widget.prototype.brindesDaBarra = function (i) {
    return (this.cfg.brindes || []).filter(function (g) { return g.na_barra && qtdBrinde(g, i) > 0; });
  };
  Widget.prototype.renderBrindesNaBarra = function () {
    var self = this;
    this.barras.forEach(function (b, i) {
      var cont = self.nosBarras[i] && self.nosBarras[i].brindes; if (!cont) return;
      cont.innerHTML = '';
      self.brindesDaBarra(i).forEach(function (g) {
        var q = qtdBrinde(g, i), d = self.extras[g.handle];
        var linha = el('div', 'ewc-bundle__brinde'); linha.setAttribute('data-ewc-gift', g.handle);
        var principal = el('div', 'ewc-bundle__brinde-main');
        var fig = el('div', 'ewc-bundle__brinde-fig');
        if (d && d.imagem) { var im = el('img', 'ewc-bundle__brinde-img'); im.src = d.imagem; im.alt = ''; fig.appendChild(im); }
        principal.appendChild(fig);
        var conteudo = el('div', 'ewc-bundle__brinde-conteudo');
        conteudo.appendChild(el('span', 'ewc-bundle__brinde-texto', (g.textos && g.textos[String(i + 1)]) || (d ? d.titulo : g.handle)));
        principal.appendChild(conteudo); linha.appendChild(principal);
        // preço de tabela: o compare-at que a loja entrega; se o mercado não o entregar (há mercados que zeram
        // o compare-at na vitrine), vale o `valor` gravado no arquivo de ofertas
        var tabela = (d && d.compare) || (g.valor ? Math.round(g.valor * 100) : 0);
        linha.appendChild(el('div', 'ewc-bundle__brinde-cheio', tabela ? enxuto(dinheiro(tabela * q, self.fmt)) : ''));
        cont.appendChild(linha);
      });
    });
  };

  Widget.prototype.renderUnidades = function (i) {
    var self = this, b = this.barras[i], n = this.nosBarras[i], cont = n.unidades;
    cont.innerHTML = '';
    if (this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) return;
    var padrao = this.variantePadrao();
    var rotulo = this.cfg.textos && this.cfg.textos.variantes;
    if (rotulo) cont.appendChild(el('div', 'ewc-bundle__unidades-rotulo', rotulo));
    for (var u = 0; u < b.q; u++) {
      if (!this.unidades[i][u]) this.unidades[i][u] = padrao.opcoes.slice();
      var linha = el('div', 'ewc-bundle__unidade' + (b.q === 1 ? ' ewc-bundle__unidade--unica' : '')); linha.appendChild(el('span', 'ewc-bundle__unidade-n', '#' + (u + 1)));
      this.vars.opcoes.forEach(function (nomeOpcao, k) {
        var escolha = self.unidades[i][u];
        var valores = self.vars.valoresDisponiveis(k, escolha);
        var swatch = self.cfg.swatches && self.cfg.swatches.opcao && self.cfg.swatches.opcao.toLowerCase() === String(nomeOpcao).toLowerCase() && self.cfg.swatches.cores;
        if (swatch) {
          var grupo = el('div', 'ewc-bundle__swatches'); grupo.setAttribute('role', 'radiogroup'); grupo.setAttribute('aria-label', nomeOpcao);
          valores.forEach(function (x) {
            var s = el('span', 'ewc-bundle__swatch'); s.title = x.valor; s.style.background = self.cfg.swatches.cores[x.valor] || '#ccc';
            s.classList.toggle('is-on', escolha[k] === x.valor); s.classList.toggle('is-off', !x.disponivel);
            s.setAttribute('data-ewc-opt', k); s.setAttribute('data-ewc-val', x.valor); s.setAttribute('data-ewc-un', u);
            grupo.appendChild(s);
          });
          linha.appendChild(grupo);
        } else {
          var s = el('select'); s.setAttribute('data-ewc-opt', k); s.setAttribute('data-ewc-un', u); s.setAttribute('aria-label', nomeOpcao);
          valores.forEach(function (x) { var o = el('option', null, x.valor + (x.disponivel ? '' : ' (Sold out)')); o.value = x.valor; o.disabled = !x.disponivel; s.appendChild(o); });
          s.value = escolha[k];
          linha.appendChild(s);
        }
      });
      cont.appendChild(linha);
    }
  };

  Widget.prototype.renderExtras = function (i) {
    var self = this, n = this.nosBarras[i], cont = n.extras; cont.innerHTML = '';
    var ups = (this.cfg.upsells || []).filter(function (u) { return !u.por_barra || !u.por_barra.length || u.por_barra.indexOf(i + 1) !== -1; });
    ups.forEach(function (u) {
      var linha = el('label', 'ewc-bundle__extra'); var cb = el('input'); cb.type = 'checkbox'; cb.setAttribute('data-ewc-upsell', u.handle);
      cb.checked = !!u.pre_marcado || (self.marcados && self.marcados[u.handle] === true);
      linha.appendChild(cb);
      var d = self.extras[u.handle];
      if (d && d.imagem) { var im = el('img'); im.src = d.imagem; im.alt = ''; linha.appendChild(im); }
      var txt = el('span', null, d ? d.titulo : u.handle);
      if (u.gratis) { txt.appendChild(document.createTextNode(' ')); txt.appendChild(el('span', 'ewc-bundle__extra-gratis', self.cfg.textos && self.cfg.textos.gratis || 'FREE')); if (d && d.compare) txt.appendChild(el('span', 'ewc-bundle__cheio', enxuto(dinheiro(d.compare, self.fmt)))); }
      else if (d) txt.appendChild(document.createTextNode(' ' + enxuto(dinheiro(d.preco, self.fmt))));
      linha.appendChild(txt); cont.appendChild(linha);
    });
    (this.cfg.brindes || []).filter(function (g) { return !g.na_barra; }).forEach(function (g) {
      var livre = (i + 1) >= (g.a_partir_da_barra || 1);
      var linha = el('div', 'ewc-bundle__extra' + (livre ? '' : ' is-locked')); linha.setAttribute('data-ewc-gift', g.handle);
      var d = self.extras[g.handle];
      if (d && d.imagem) { var im = el('img'); im.src = d.imagem; im.alt = ''; linha.appendChild(im); }
      var txt = el('span', null, (d ? d.titulo : g.handle) + ' ');
      txt.appendChild(el('span', 'ewc-bundle__extra-gratis', livre ? (g.rotulo || 'FREE') : (self.cfg.textos && self.cfg.textos.travado || 'Locked')));
      if (d && d.compare) txt.appendChild(el('span', 'ewc-bundle__cheio', enxuto(dinheiro(d.compare, self.fmt))));
      linha.appendChild(txt); cont.appendChild(linha);
    });
  };

  Widget.prototype.carregarExtras = function () {
    var self = this, handles = [];
    (this.cfg.upsells || []).concat(this.cfg.brindes || []).forEach(function (x) { if (x.handle && handles.indexOf(x.handle) === -1) handles.push(x.handle); });
    handles.forEach(function (h) {
      fetch(self.raiz + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        self.extras[h] = { titulo: p.title, preco: v ? v.price : 0, compare: v && v.compare_at_price > v.price ? v.compare_at_price : (v && v.price === 0 && v.compare_at_price ? v.compare_at_price : 0),
                           variante: v ? v.id : null, imagem: (p.featured_image || '').replace(/(\.[a-z]+)(\?.*)?$/i, '_64x64$1$2') };
        self.renderExtras(self.selecionada); self.renderBrindesNaBarra();
      }).catch(function () {});
    });
  };

  Widget.prototype.itens = function () {
    var b = this.barras[this.selecionada], contagem = {}, ordem = [];
    var padrao = this.variantePadrao();
    for (var u = 0; u < b.q; u++) {
      var v = (this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) ? padrao : (this.vars.porOpcoes(this.unidades[this.selecionada][u] || padrao.opcoes) || padrao);
      if (!(v.id in contagem)) { contagem[v.id] = 0; ordem.push(v.id); }
      contagem[v.id]++;
    }
    var itens = ordem.map(function (id) { return { id: parseInt(id, 10), quantity: contagem[id], properties: { _ewc_bundle: b.titulo || String(b.q) } }; });
    var self = this;
    this.root.querySelectorAll('[data-ewc-upsell]:checked').forEach(function (cb) {
      var h = cb.getAttribute('data-ewc-upsell'), d = self.extras[h];
      if (d && d.variante) itens.push({ id: d.variante, quantity: 1, properties: { _ewc_upsell: '1' } });
    });
    (this.cfg.brindes || []).forEach(function (g) {
      var q = qtdBrinde(g, self.selecionada); if (!q) return;
      var vid = g.variante_id || (self.extras[g.handle] && self.extras[g.handle].variante);
      if (vid) itens.push({ id: parseInt(vid, 10), quantity: q, properties: { _ewc_gift: '1' } });
    });
    return itens;
  };

  Widget.prototype.atualizarForm = function () {
    var b = this.barras[this.selecionada]; this.propriedade.value = b.titulo || String(b.q);
    var distintos = {}; this.itens().forEach(function (i) { if (!i.properties._ewc_upsell && !i.properties._ewc_gift) distintos[i.id] = 1; });
    var multi = Object.keys(distintos).length > 1 || b.q > 1;
    this.form.classList.toggle('ewc-multi-variant', multi && this.cfg.esconder_expresso !== false);
    var sec = this.form.closest('.shopify-section,section'); if (sec) sec.classList.toggle('ewc-multi-variant', multi && this.cfg.esconder_expresso !== false);
    var bd = this.cfg.botao_dinamico;
    if (bd && bd.modelo) {
      var btn = this.form.querySelector('button[name="add"],[type="submit"]');
      var alvo = btn && (btn.querySelector('span') || btn);
      if (alvo) {
        if (!btn.hasAttribute('data-ewc-texto-original')) btn.setAttribute('data-ewc-texto-original', alvo.textContent);
        var conta = this.contaDaBarra(this.selecionada), total = conta.total, cheio = conta.cheio;
        var economia = Math.max(0, cheio - total);
        var novo = economia > 0 ? bd.modelo.replace('{{economia}}', enxuto(dinheiro(economia, this.fmt))) : btn.getAttribute('data-ewc-texto-original');
        if (alvo.textContent !== novo) alvo.textContent = novo;
      }
    }
  };

  Widget.prototype.ligar = function () {
    var self = this;
    this.root.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t.name === 'ewc-bundle-bar' + self.inst) {
        self.selecionada = parseInt(t.value, 10); self.fecharLista(); self.render();
        // trocar de barra leva a página para a variante da 1ª unidade da barra nova (o app faz o mesmo)
        var un1 = self.unidades[self.selecionada] && self.unidades[self.selecionada][0];
        if (un1) self.sincronizar(self.vars.porOpcoes(un1));
        return;
      }
      if (t.tagName === 'SELECT' && t.hasAttribute('data-ewc-opt')) {
        var k = parseInt(t.getAttribute('data-ewc-opt'), 10), u = parseInt(t.getAttribute('data-ewc-un'), 10);
        var esc = self.unidades[self.selecionada][u]; esc[k] = t.value;
        for (var j = k + 1; j < self.vars.opcoes.length; j++) { var vals = self.vars.valoresDisponiveis(j, esc); if (!vals.some(function (x) { return x.valor === esc[j]; })) esc[j] = (vals.filter(function (x) { return x.disponivel; })[0] || vals[0] || {}).valor; }
        self.render(); self.sincronizar(self.vars.porOpcoes(esc)); return;
      }
      if (t.hasAttribute('data-ewc-upsell')) { self.marcados = self.marcados || {}; self.marcados[t.getAttribute('data-ewc-upsell')] = t.checked; self.atualizarForm(); }
    });
    // lista suspensa do desenho do Kaching: a caixa abre e fecha, a opção escolhe; clique fora, Esc e
    // troca de barra fecham. Tudo dentro do rótulo da barra, então o clique não pode chegar ao rótulo
    this.root.addEventListener('click', function (ev) {
      var o = ev.target.closest && ev.target.closest('.ewc-bundle__opcao');
      if (o) { ev.preventDefault(); ev.stopPropagation(); self.escolherK(o.getAttribute('data-value')); return; }
      var cb = ev.target.closest && ev.target.closest('.ewc-bundle__select');
      if (!cb || cb.tagName === 'SELECT') return;   // a lista simples abre sozinha
      ev.preventDefault(); ev.stopPropagation();
      if (self.aberta && self.aberta.cb === cb) self.fecharLista(); else self.abrirLista(cb);
    });
    this.root.addEventListener('keydown', function (ev) {
      var cb = ev.target.closest && ev.target.closest('.ewc-bundle__select'); if (!cb || cb.tagName === 'SELECT') return;
      var a = self.aberta && self.aberta.cb === cb ? self.aberta : null;
      if (!a) { if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(ev.key) !== -1) { ev.preventDefault(); self.abrirLista(cb); } return; }
      var ops = [].slice.call(a.lista.children), atual = ops.findIndex(function (x) { return x.classList.contains('is-focused'); });
      if (ev.key === 'Escape') { ev.preventDefault(); self.fecharLista(); return; }
      if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); if (ops[atual]) self.escolherK(ops[atual].getAttribute('data-value')); return; }
      var novo = ev.key === 'ArrowDown' ? (atual + 1) % ops.length : ev.key === 'ArrowUp' ? (atual - 1 + ops.length) % ops.length
        : ev.key === 'Home' ? 0 : ev.key === 'End' ? ops.length - 1 : -1;
      if (novo < 0) return;
      ev.preventDefault(); ops.forEach(function (x, n) { x.classList.toggle('is-focused', n === novo); });
    });
    document.addEventListener('click', function (ev) { if (self.aberta && !self.aberta.cb.parentNode.contains(ev.target)) self.fecharLista(); }, true);
    window.addEventListener('scroll', function () { self.posicionarLista(); }, { passive: true });
    window.addEventListener('resize', function () { self.posicionarLista(); });
    this.root.addEventListener('click', function (ev) {
      var s = ev.target.closest && ev.target.closest('.ewc-bundle__swatch'); if (!s) return;
      ev.preventDefault();
      var k = parseInt(s.getAttribute('data-ewc-opt'), 10), u = parseInt(s.getAttribute('data-ewc-un'), 10);
      self.unidades[self.selecionada][u][k] = s.getAttribute('data-ewc-val');
      self.render();
    });
    this.form.addEventListener('submit', function (ev) {
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation(); self.comprar();
    }, true);
    this.form.setAttribute('data-ewc-bundle-form', '1');
    var self2 = this; window.addEventListener('pageshow', function () { self2.ocupado = false; var btn = self2.form.querySelector('button[name="add"],[type="submit"]'); if (btn) btn.disabled = false; });
  };

  Widget.prototype.comprar = function () {
    var self = this; if (this.ocupado) return; this.ocupado = true;
    var btn = this.form.querySelector('button[name="add"],[type="submit"]'); if (btn) btn.disabled = true;
    var itens = this.itens();
    fetch(this.raiz + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itens }) })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function (json) {
        document.dispatchEvent(new CustomEvent('ewc:cart:added', { bubbles: true, detail: { items: json.items || [json] } }));
        var depois = self.cfg.depois_de_adicionar || 'gaveta';
        if (depois === 'carrinho' || (depois === 'gaveta' && !window.EwcCart)) {
          ['cart:refresh', 'cart:build', 'cart-drawer:open', 'ajaxProduct:added'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); });
          if (depois === 'carrinho' || !document.querySelector('cart-drawer,.cart-drawer,[data-cart-drawer]')) window.location.href = self.rotas.carrinho || (self.raiz + 'cart');
        }
      })
      .catch(function () { window.location.href = self.rotas.carrinho || (self.raiz + 'cart'); })
      .then(function () { self.ocupado = false; if (btn) btn.disabled = false; });
  };

  function iniciar() {
    document.querySelectorAll('[data-ewc-bundle]').forEach(function (root) {
      if (root._ewc) return;
      try { root._ewc = new Widget(root); window.EwcBundle = root._ewc; } catch (e) { root.hidden = true; if (window.console && console.debug) console.debug('[ewc-bundle] fora do ar:', e.message); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
